module.exports = __webpack_public_path__ + "img/icon01.915852b5.png";